<template>
    <modal @close="editUserInfoCancelClick" class="edit-modal" hideFooter id="edit-user-info">
        <div class="td-edit-container one-step">
            <div class="pagination">
                <div class="form-name">
                    <h3>Edit Contact</h3>
                    <p>
                        Keep your account details current. 
                    </p>
                    <p>
                        Please review and update your contact information to ensure we can reach you with important updates and notifications.
                    </p>
                </div>
            </div>
            <div class="edit-pages">
                <form>
                    <h3>Edit Contact</h3>
                    <div class="md-col-2">
                        <div class="column">

                            <div class="mt-3">
                                <label class="td-label td-text-bold mt-0">First Name:</label>
                                <input v-model="updateModel.firstName" type="text" placeholder="" :class="{'error': userValidator.errors['firstName']}"
                                       @input="userValidator.validate('firstName')" />
                                <error v-if="userValidator.errors['firstName']" :error="userValidator.errors['firstName']"></error>
                            </div>

                            <div class="mt-3">
                                <label class="td-label td-text-bold mt-0">Last Name:</label>
                                <input v-model="updateModel.lastName" type="text" placeholder="" :class="{'error': userValidator.errors['lastName']}"
                                       @input="userValidator.validate('lastName')" />
                                <error v-if="userValidator.errors['lastName']" :error="userValidator.errors['lastName']"></error>
                            </div>

                            <div class="mt-3">
                                <label class="td-label td-text-bold mt-0">Office:</label>
                                <input v-model="updateModel.office" type="text" placeholder="" :class="{'error': userValidator.errors['office']}"
                                       @input="userValidator.validate('office')" />
                                <error v-if="userValidator.errors['office']" :error="userValidator.errors['office']"></error>
                            </div>

                            <div class="mt-3">
                                <label class="td-label td-text-bold mt-0">Home:</label>
                                <input v-model="updateModel.home" type="text" placeholder="" :class="{'error': userValidator.errors['home']}" />
                                <error v-if="userValidator.errors['home']" :error="userValidator.errors['home']"></error>
                            </div>

                            <div class="mt-3">
                                <label class="td-label td-text-bold mt-0">Fax:</label>
                                <input v-model="updateModel.fax" type="text" placeholder="" :class="{'error': userValidator.errors['fax']}"
                                       @input="userValidator.validate('fax')" />
                                <error v-if="userValidator.errors['fax']" :error="userValidator.errors['fax']"></error>
                            </div>
                        </div>
                        <div class="column">


                        </div>
                    </div>
                </form>

                <div class="actions">
                    <div>
                        <button class="td-btn primary-outlined" @click="editUserInfoCancelClick">Cancel</button>
                    </div>
                    <div class="save-btn">
                        <button class="td-btn btn primary" @click="editUserInfoSaveClick"><span v-if="isLoading"><icon name="faSpinner" type="solid" spin></icon>&nbsp;</span>Save</button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import script from './EditUserInfo';
    export default script;
</script>
<style lang="less">
    @import './EditUserInfo.less';
</style>